<style lang="sass">

    @import ../../common/styles/settings
    @import ../../common/styles/mixins

    .dsp-search
        background: darken($color-background-light, 5%) url(../../common/assets/background-filigrane-darker.svg) no-repeat center 30%/250% 250% !important
        padding: $baseline*2
        margin-bottom: $baseline*2

        &__error
            display: block
            position: absolute
            margin-top: $baseline*.5
            color: $color-error
            font-size: .625rem
            font-weight: 400
            letter-spacing: .025em

        &__field
            position: relative
            max-width: 25em
            margin: $baseline auto 0

        &__input
            width: 100%
            padding: $baseline*.75 $baseline*2 $baseline*.75 $baseline
            background-color: white
            border: none
            box-sizing: border-box
            box-shadow: 0 0 0.625em 0 rgba(0, 0, 0, 0.1)
            outline: 0

        &__title
            text-align: center
            max-width: 30em

        button
            position: absolute
            top: $baseline*.325
            right: $baseline*.75
            background-color: transparent
            border: none
            height: $baseline*1.5
            width: $baseline*1.5
            outline: 0

            span
                display: none

            svg
                height: inherit
                width: inherit

    .dsp-slide-enter-active,
    .dsp-slide-leave-active
        transition: opacity $speed-fast $authentic-motion, transform $speed-fast $authentic-motion

    .dsp-slide-enter,
    .dsp-slide-leave-to
        transform: translateY(-100%)
        opacity: 0

</style>

<script setup>
    import {ref} from 'vue'
    const formRef = ref(null)
    const zipcode = ref('');
    function submit () {
        this.$validator.validateAll().then((result) => {
            if (result) {
                send()
            }
        })
    };
    function  send () {
        let form = formRef.value;
        let action = `${form.getAttribute('action')}?zipcode=${zipcode}`

        form.setAttribute('action', action)
        form.submit()
    }
</script>
